import React from 'react';
import { LucideIcon, LucideProps, DollarSign, Euro, PoundSterling } from 'lucide-react';
import { getActiveCurrency, getCurrencySymbol } from '@/utils/currency';

/** Renders currency-appropriate money icon (Rs / $ / £ / €). */
export const CurrencyIcon: LucideIcon = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, className = '', strokeWidth = 2, ...props }, ref) => {
    const code = getActiveCurrency();
    if (code === 'USD') {
      return <DollarSign ref={ref} size={size} className={className} strokeWidth={strokeWidth} {...props} />;
    }
    if (code === 'EUR') {
      return <Euro ref={ref} size={size} className={className} strokeWidth={strokeWidth} {...props} />;
    }
    if (code === 'GBP') {
      return <PoundSterling ref={ref} size={size} className={className} strokeWidth={strokeWidth} {...props} />;
    }
    // Default: Rs-style glyph (PKR and others without lucide icon)
    const symbol = getCurrencySymbol(code);
    if (symbol !== 'Rs') {
      return (
        <span
          ref={ref as React.Ref<HTMLSpanElement>}
          className={`inline-flex items-center justify-center font-semibold ${className}`}
          style={{ width: size, height: size, fontSize: Math.max(10, Number(size) * 0.55) }}
        >
          {symbol}
        </span>
      ) as unknown as React.ReactElement;
    }
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`lucide lucide-pak-rupee ${className}`}
        {...props}
      >
        <path d="M4 19V5h5a4 4 0 0 1 0 8H4" />
        <path d="m8 13 5 6" />
        <path d="M19 11h-2a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2h0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2h-2" />
      </svg>
    );
  },
) as unknown as LucideIcon;

/** @deprecated Use CurrencyIcon — kept for existing imports */
export const PakRupeeIcon = CurrencyIcon;

export default CurrencyIcon;
